import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'
import RouteViewComponent from '../layouts/RouterBypass.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'dashboard' },
  },
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    redirect: { name: 'dashboard' },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('../pages/admin/dashboard/Dashboard.vue'),
        beforeEnter: (to, from, next) => {
          const userStr = localStorage.getItem('user')
          if (userStr) {
            try {
              const user = JSON.parse(userStr)
              const userRole = user.role

              if (userRole === 'Super Administrateur') {
                return next({ name: 'dashboard-super-admin' })
              } else if (userRole === 'Administrateur' || userRole === 'Secrétaire') {
                return next({ name: 'dashboard-admin' })
              }
              // Collaborateur continue vers Dashboard.vue par défaut
            } catch (error) {
              console.error('Erreur lors de la lecture du rôle:', error)
            }
          }
          next()
        },
      },
      {
        name: 'dashboard-admin',
        path: 'dashboard-admin',
        component: () => import('../pages/admin/dashboard/DashboardAdmin.vue'),
      },
      {
        name: 'dashboard-super-admin',
        path: 'dashboard-super-admin',
        component: () => import('../pages/admin/dashboard/DashboardSuperAdmin.vue'),
      },
      {
        name: 'general-report',
        path: 'general-report',
        component: () => import('../pages/admin/general-report/GeneralReport.vue'),
      },
      {
        name: 'clients',
        path: 'clients',
        component: RouteViewComponent,
        children: [
          { name: 'create-client', path: 'create', component: () => import('../pages/admin/clients/CreateClient.vue') },
          { name: 'list-clients', path: 'list', component: () => import('../pages/admin/clients/ListClients.vue') },
          {
            name: 'archived-clients',
            path: 'archived',
            component: () => import('../pages/admin/clients/ArchivedClients.vue'),
          },
        ],
      },
      {
        name: 'missions',
        path: 'missions',
        component: RouteViewComponent,
        children: [
          {
            name: 'create-diligence',
            path: 'create-diligence',
            component: () => import('../pages/admin/missions/CreateDiligence.vue'),
          },
          {
            name: 'diligence-history',
            path: 'diligence-history',
            component: () => import('../pages/admin/missions/DiligenceHistory.vue'),
          },
          {
            name: 'create-attestation',
            path: 'create-attestation',
            component: () => import('../pages/admin/missions/CreateAttestation.vue'),
          },
          {
            name: 'create-mission',
            path: 'create-mission',
            component: () => import('../pages/admin/missions/CreateMission.vue'),
          },
          {
            name: 'attestation-history',
            path: 'attestation-history',
            component: () => import('../pages/admin/missions/AttestationHistory.vue'),
          },
          {
            name: 'attestation-detail',
            path: 'attestation-detail/:id',
            component: () => import('../pages/admin/missions/AttestationDetail.vue'),
          },
          {
            name: 'mission-history',
            path: 'mission-history',
            component: () => import('../pages/admin/missions/MissionHistory.vue'),
          },
          {
            name: 'cancel-attestation',
            path: 'cancel-attestation',
            component: () => import('../pages/admin/missions/CancelAttestation.vue'),
          },
        ],
      },
      {
        name: 'documents',
        path: 'documents',
        component: RouteViewComponent,
        children: [
          { name: 'add-document', path: 'add', component: () => import('../pages/admin/documents/AddDocument.vue') },
          {
            name: 'list-documents',
            path: 'list',
            component: () => import('../pages/admin/documents/ListDocuments.vue'),
          },
        ],
      },
      {
        name: 'payments',
        path: 'payments',
        component: RouteViewComponent,
        children: [
          {
            name: 'initiate-payment',
            path: 'initiate',
            component: () => import('../pages/admin/payments/InitiatePayment.vue'),
          },
          {
            name: 'perform-payment',
            path: 'perform',
            component: () => import('../pages/admin/payments/PerformPayment.vue'),
          },
          { name: 'payment-history', path: 'history', component: () => import('../pages/payments/PaymentHistory.vue') },
          {
            name: 'payment-detail-history',
            path: 'detail-history/:paymentId',
            component: () => import('../pages/payments/DetailHistory.vue'),
          },
          { name: 'minipay', path: 'minipay', component: () => import('../pages/admin/payments/MiniPay.vue') },
          {
            name: 'transfer-journal',
            path: 'journal',
            component: () => import('../pages/admin/payments/TransferJournal.vue'),
          },
        ],
      },
      {
        name: 'stickers',
        path: 'stickers',
        component: RouteViewComponent,
        children: [
          { name: 'enter-sticker', path: 'enter', component: () => import('../pages/admin/stickers/EnterSticker.vue') },
          { name: 'exit-sticker', path: 'exit', component: () => import('../pages/admin/stickers/ExitSticker.vue') },
          { name: 'stock-sticker', path: 'stock', component: () => import('../pages/admin/stickers/StockSticker.vue') },
        ],
      },
      { name: 'expenses', path: 'expenses', component: () => import('../pages/admin/expenses/ExpensesPage.vue') },
      {
        name: 'caisse',
        path: 'caisse',
        component: RouteViewComponent,
        children: [
          {
            name: 'validation-transfert',
            path: 'validation-transfert',
            component: () => import('../pages/admin/caisse/ValidationTransfert.vue'),
          },
          {
            name: 'validation-depense',
            path: 'validation-depense',
            component: () => import('../pages/admin/caisse/ValidationDepense.vue'),
          },
          {
            name: 'visuelle-caisse',
            path: 'visuelle-caisse',
            component: () => import('../pages/admin/caisse/VisuelleCaisse.vue'),
          },
        ],
      },
      {
        name: 'bank',
        path: 'bank',
        component: RouteViewComponent,
        children: [
          {
            name: 'solde-en-banque',
            path: 'solde-en-banque',
            component: () => import('../pages/admin/bank/SoldeEnBanque.vue'),
          },
          {
            name: 'mouvement-transactions',
            path: 'mouvement-transactions',
            component: () => import('../pages/admin/bank/MouvementTransactions.vue'),
          },
        ],
      },
      {
        name: 'receivables',
        path: 'receivables',
        component: RouteViewComponent,
        children: [
          {
            name: 'receivables-list',
            path: 'list',
            component: () => import('../pages/admin/receivables/Receivables.vue'),
          },
          {
            name: 'non-invoiced',
            path: 'non-invoiced',
            component: () => import('../pages/admin/receivables/NonInvoiced.vue'),
          },
        ],
      },
      {
        name: 'contributors',
        path: 'contributors',
        component: RouteViewComponent,
        children: [
          {
            name: 'add-contributor',
            path: 'add',
            component: () => import('../pages/admin/contributors/AddContributor.vue'),
          },
          {
            name: 'list-contributors',
            path: 'list',
            component: () => import('../pages/admin/contributors/ListContributors.vue'),
          },
          {
            name: 'pay-commission',
            path: 'pay',
            component: () => import('../pages/admin/contributors/PayCommission.vue'),
          },
          {
            name: 'settle-commission',
            path: 'settle',
            component: () => import('../pages/admin/contributors/SettleCommission.vue'),
          },
          {
            name: 'commission-history',
            path: 'history',
            component: () => import('../pages/admin/contributors/CommissionHistory.vue'),
          },
        ],
      },
      {
        name: 'statistics',
        path: 'statistics',
        component: RouteViewComponent,
        children: [
          {
            name: 'client-report',
            path: 'client',
            component: () => import('../pages/admin/statistics/ClientReport.vue'),
          },
          {
            name: 'attestation-report',
            path: 'attestation',
            component: () => import('../pages/admin/statistics/AttestationReport.vue'),
          },
          {
            name: 'mission-report',
            path: 'mission',
            component: () => import('../pages/admin/statistics/MissionReport.vue'),
          },
          {
            name: 'finance-report',
            path: 'finance',
            component: () => import('../pages/admin/statistics/FinanceReport.vue'),
          },
          {
            name: 'annual-client-report',
            path: 'annual',
            component: () => import('../pages/admin/statistics/AnnualClientReport.vue'),
          },
          {
            name: 'fiscal-report',
            path: 'fiscal',
            component: () => import('../pages/admin/statistics/FiscalReport.vue'),
          },
        ],
      },
      {
        name: 'other',
        path: 'other',
        component: RouteViewComponent,
        children: [
          {
            name: 'appointments',
            path: 'appointments',
            component: () => import('../pages/admin/other/Appointments.vue'),
          },
          { name: 'notes', path: 'notes', component: () => import('../pages/admin/other/Notes.vue') },
          {
            name: 'permission-request',
            path: 'permission-request',
            component: () => import('../pages/admin/other/PermissionRequest.vue'),
          },
          {
            name: 'manage-permissions',
            path: 'manage-permissions',
            component: () => import('../pages/admin/other/ManagePermissions.vue'),
          },
          {
            name: 'pilotage-operationnel',
            path: 'pilotage-operationnel',
            component: () => import('../pages/admin/other/PilotageOperationnel.vue'),
          },
        ],
      },
      {
        name: 'communications',
        path: 'communications',
        component: RouteViewComponent,
        children: [
          { name: 'chatbox', path: 'chatbox', component: () => import('../pages/communications/ChatBox.vue') },
          { name: 'mailbox', path: 'mailbox', component: () => import('../pages/communications/MailBox.vue') },
        ],
      },
      {
        name: 'settings-main',
        path: 'settings-main',
        component: RouteViewComponent,
        children: [
          { name: 'company-settings', path: 'company', component: () => import('../pages/admin/settings/Company.vue') },
          { name: 'users-settings', path: 'users', component: () => import('../pages/users/UsersPage.vue') },
          { name: 'banks-settings', path: 'banks', component: () => import('../pages/settings/Banks.vue') },
          {
            name: 'chatbox-settings',
            path: 'chatbox-settings',
            component: () => import('../pages/settings/ParametreChatBox.vue'),
          },
          {
            name: 'mailbox-settings',
            path: 'mailbox-settings',
            component: () => import('../pages/settings/ParametreMailBox.vue'),
          },
          {
            name: 'fiscal-regime-settings',
            path: 'fiscal-regime',
            component: () => import('../pages/settings/FiscalRegime.vue'),
          },
          {
            name: 'general-settings',
            path: 'general-settings',
            component: () => import('../pages/settings/Settings.vue'),
          },
          {
            name: 'attestation-types',
            path: 'attestation-types',
            component: () => import('../pages/settings/AttestationTypes.vue'),
          },
          {
            name: 'mission-types',
            path: 'mission-types',
            component: () => import('../pages/settings/MissionTypes.vue'),
          },
          { name: 'report-types', path: 'report-types', component: () => import('../pages/settings/ReportTypes.vue') },
          {
            name: 'expense-types',
            path: 'expense-types',
            component: () => import('../pages/settings/ExpenseTypes.vue'),
          },
          {
            name: 'permission-types',
            path: 'permission-types',
            component: () => import('../pages/settings/PermissionTypes.vue'),
          },
          { name: 'objectives', path: 'objectives', component: () => import('../pages/settings/Objectives.vue') },
        ],
      },
      { name: 'preferences', path: 'preferences', component: () => import('../pages/preferences/Preferences.vue') },
      {
        name: 'change-password',
        path: 'change-password',
        component: () => import('../pages/admin/settings/ChangePassword.vue'),
      },
      { name: 'settings', path: 'settings', component: () => import('../pages/settings/Settings.vue') },
      { name: 'users', path: 'users', component: () => import('../pages/users/UsersPage.vue') },
      { name: 'projects', path: 'projects', component: () => import('../pages/projects/ProjectsPage.vue') },
      { name: 'faq', path: '/faq', component: () => import('../pages/faq/FaqPage.vue') },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      { name: 'login', path: 'login', component: () => import('../pages/auth/Login.vue') },
      { name: 'signup', path: 'signup', component: () => import('../pages/auth/Signup.vue') },
      {
        name: 'recover-password',
        path: 'recover-password',
        component: () => import('../pages/auth/RecoverPassword.vue'),
      },
      {
        name: 'recover-password-email',
        path: 'recover-password-email',
        component: () => import('../pages/auth/CheckTheEmail.vue'),
      },
      { name: 'lock', path: 'lock', component: () => import('../pages/auth/Lock.vue') },
      { path: '', redirect: { name: 'login' } },
    ],
  },
  { name: '404', path: '/404', component: () => import('../pages/404.vue') },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    }
    window.scrollTo(0, 0)
  },
  routes,
})

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || `${window.location.origin}/api`

const hasValidBackendSession = async (userId: number): Promise<boolean> => {
  try {
    const response = await fetch(`${apiBaseUrl}/users/${userId}`, {
      method: 'GET',
      credentials: 'include',
    })

    // On autorise l'acces uniquement si la session backend est valide.
    return response.ok
  } catch {
    // Politique stricte: en cas d'erreur, on bloque l'acces aux routes protegees.
    return false
  }
}

// Navigation guard pour vérifier l'authentification
router.beforeEach(async (to, from, next) => {
  const publicPages = ['login', 'signup', 'recover-password', 'recover-password-email', 'lock']
  const authRequired = !publicPages.includes(to.name as string)
  const userStr = localStorage.getItem('user')

  if (authRequired && !userStr) {
    // Utilisateur non connecté, rediriger vers login
    return next({ name: 'login' })
  }

  if (authRequired && userStr) {
    try {
      const user = JSON.parse(userStr)
      const userId = Number(user?.id)

      if (!Number.isFinite(userId)) {
        localStorage.removeItem('user')
        return next({ name: 'login' })
      }

      const sessionOk = await hasValidBackendSession(userId)
      if (!sessionOk) {
        localStorage.removeItem('user')
        return next({ name: 'login' })
      }
    } catch {
      localStorage.removeItem('user')
      return next({ name: 'login' })
    }
  }

  if (to.name === 'login' && userStr) {
    // Utilisateur déjà connecté, rediriger vers son dashboard approprié
    try {
      const user = JSON.parse(userStr)
      const userRole = user.role

      if (userRole === 'Collaborateur') {
        return next({ name: 'dashboard' })
      } else if (userRole === 'Administrateur' || userRole === 'Secrétaire') {
        return next({ name: 'dashboard-admin' })
      } else if (userRole === 'Super Administrateur') {
        return next({ name: 'dashboard-super-admin' })
      } else {
        return next({ name: 'dashboard' })
      }
    } catch (error) {
      console.error('Erreur lors de la lecture des données utilisateur:', error)
      localStorage.removeItem('user')
      return next({ name: 'login' })
    }
  }

  next()
})

export default router
